import React, {Component} from 'react';
import {Button, Form, FormControl, FormGroup, InputGroup} from 'react-bootstrap';
import Select from 'react-select';

import InfiniteScroll from "react-infinite-scroll-component";
import DesignResourcesPanel from '../designResourcesPanel';

const PageSize = 20;

const categorySelectionStyles = {

    option: (provided, state) => ({
        ...provided,
        textAlign: 'left',
        backgroundColor: state.isSelected ? '#C8CDD4' : (state.isFocused ? '#F1F2F3' : 'white'),
    }),

    menu: (provided, state) => ({
        ...provided,
        width: '275px'
    })
};


var default_drag_ghost = new window.Image();
default_drag_ghost.id = 'drag_image';
default_drag_ghost.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

class TemplatesPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 0,
            searchActive: false,
            searchKeywords: '',
            selectedCategory: {value: null, label: "All"},
            categories: [],
            fetchingDefaultCategory: false,
            defaultCategoryAlreadySet: false
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));


    handleCategoryChange =  (e, extra_options) => {

        let prevPage = this.state.page;

        let st = {
            selectedCategory: e,
            data: [],
            page: 0
        };

        if (extra_options) {
            for (let key in extra_options) {
                if (extra_options.hasOwnProperty(key)) {
                    st[key] = extra_options[key];
                }
            }
        }

        this.set_state(st)
            .then(() => {
                if (prevPage <= 2) this.fetchData();
            });
    };


    componentDidMount() {

        fetch(global.config.server_path + 'category/get', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            'credentials': 'include',
            'body': JSON.stringify({'type': 'design', 'filter_empty': true, active: true})
        })
        .then(resp => resp.json())
        .then(resp => {
            resp = resp.data;
            resp = resp.filter(x => x.parent);
            resp = resp.map(x => {
                return {label: x.name, value: x._id}
            });
            resp = resp.sort(function (a, b) {
                return (a.label < b.label) ? -1 : 1;
            });
            resp.unshift({"label": "All", value: null});

            let params = new URLSearchParams(window.location.search);
            let category = params.get('category');

            if (!category && this.props.defaultCategory) category = this.props.defaultCategory;

            if (category) {
                const selectedCategory = resp.find(x => x.value === category);
                if (selectedCategory) {
                    this.handleCategoryChange(selectedCategory, {defaultCategoryAlreadySet: true});
                }
            } else {
                fetch(global.config.server_path + 'design/get/', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    'credentials': 'include',
                    body: JSON.stringify({
                        page_no: this.state.page,
                        size: PageSize,
                        active: true
                    })
                })
                .then(resp => resp.json())
                .then(resp => {
                    if (!this.state.fetchingDefaultCategory) {
                        let results = resp.data.docs;
                        this.setState({
                            data: this.state.data.concat(results),
                            page: this.state.page + 1
                        })
                        var infinite_scrolls = window.document.getElementsByClassName('infinite-scroll-component');
                        if(infinite_scrolls && infinite_scrolls.length>0){
                            for (var i = 0; i < infinite_scrolls.length; i++) {
                                infinite_scrolls[i].dispatchEvent(new window.Event('scroll'));
                            }
                        }
                    }
                })
                .catch(error => Promise.reject(error))
            }
            this.setState({categories: resp})
        })
        .catch(error => console.error(error))
    }

    componentDidUpdate(prevProps) {
        if (!this.state.defaultCategoryAlreadySet && prevProps.defaultCategory !== this.props.defaultCategory) {
            const selectedCategory = this.state.categories.find(x => x.value === this.props.defaultCategory);
            if (selectedCategory) {
                this.setState({
                    fetchingDefaultCategory : true
                }, () => this.handleCategoryChange(selectedCategory, {defaultCategoryAlreadySet: true}));
            }
        }
    }

    handleSearchOnChange = (e) => {
        this.setState({
            searchKeywords: e.target.value
        });

        if (e.target.value === "") {
            this.handleSearchClear();
        }
    };

    load_template = async (template,event) => {
        var cloned_file = JSON.parse(JSON.stringify(template.design_file))
       
        for(var i=0;i<cloned_file.pages.length;i++){
            window.refresh_ids_struct(cloned_file.pages[i])
        }
        
        await window.design_editor.design.load(cloned_file,event.target)
        if (this.state.selectedCategory && this.state.selectedCategory.value) {
            window.design_editor.category_id = this.state.selectedCategory.value
        }

        window.design_editor.needs_redraw = true;
        window.design_editor.addUndoChange()
        window.design_editor.deselectElements();

        this.props.rct_update_pages(window.design_editor.design.pages.length);

        window.design_editor.handleWindowResize()
    };

    template_drag_start = (template, event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }
        
        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0
        event.dataTransfer.setData("image", event.target);
        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'template',
            data: {type: 'template', data: template}
        }
    };

    template_drag = (template, event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }
        if(window.design_editor.drag_details){
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    };

    template_drag_end = (template, event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if(elem && elem.parentElement){
            elem.parentElement.removeChild(elem);
        }
        if(window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement){
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);   
        }

        if (this.state.selectedCategory && this.state.selectedCategory.value) {
            window.design_editor.category_id = this.state.selectedCategory.value
        }

        window.design_editor.handleDrop(event.target);
        window.design_editor.drag_ghost_image = null;
        window.design_editor.drag_details = null;
        event.preventDefault();
    };


    fetchSearchResults = () => {

        let url = global.config.server_path + 'design_templates/_search?';

        let queryBody = {
            "from": (this.state.page * PageSize),
            "size": PageSize,
            "query": {
                "bool": {
                    "must": {
                        "multi_match": {
                            "query": this.state.searchKeywords,
                            "fields": ["categories.name", "keywords^3", "name", "design_text"],
                            "operator": "or",
                            "type": "best_fields"
                        }
                    },
                    "filter" : []
                }
            }
        };

        if (this.state.selectedCategory.value) {
            queryBody["query"]["bool"]["filter"].push({"terms": {"categories.name.keyword": [this.state.selectedCategory.label]}});
        }

        queryBody["query"]["bool"]["filter"].push({"term" : {"active": true}});


        fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(queryBody)})
            .then(resp => resp.json())
            .then(resp => resp.hits.hits.map(x => x._id))
            .then(resp => {
                let url = global.config.server_path + 'design/get/';
                let payload = {
                    id: resp,
                    active : true
                };
                if (this.state.selectedCategory.value) payload['category_id'] = this.state.selectedCategory.value;
                return fetch(url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    'credentials': 'include',
                    body: JSON.stringify(payload)
                });
            })
            .then(resp => resp.json())
            .then(resp => {
                let searchResults = resp.data.docs;
                if (searchResults) {
                    this.set_state({
                        data: this.state.data.concat(searchResults),
                        page: this.state.page + 1
                    }).then(() => {
                        var infinite_scrolls = window.document.getElementsByClassName('infinite-scroll-component');
                        if(infinite_scrolls && infinite_scrolls.length>0){
                            for (var i = 0; i < infinite_scrolls.length; i++) {
                                infinite_scrolls[i].dispatchEvent(new window.Event('scroll'));
                            }
                        }
                    })
                }
            })
            .catch(err => console.log(err))
    };


    fetchTemplates = () => {

        let payload = {
            page_no: this.state.page,
            size: PageSize,
            active : true
        };

        if (this.state.selectedCategory.value) payload['category_id'] = this.state.selectedCategory.value;
        fetch(global.config.server_path + 'design/get/', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            'credentials': 'include',
            body: JSON.stringify(payload)
        })
            .then(resp => resp.json())
            .then(resp => {
                let results = resp.data.docs;
                this.set_state({
                    data: this.state.data.concat(results),
                    page: this.state.page + 1
                }).then(() => {
                    var infinite_scrolls = window.document.getElementsByClassName('infinite-scroll-component');
                    if(infinite_scrolls && infinite_scrolls.length>0){
                        for (var i = 0; i < infinite_scrolls.length; i++) {
                            infinite_scrolls[i].dispatchEvent(new window.Event('scroll'));
                        }
                    }
                })
            })
            .catch(err => console.log(err))
    };


    fetchData = () => {
        if (this.state.searchActive) {
            this.fetchSearchResults();
        } else {
            this.fetchTemplates();
        }
    };

    handleSearchClear = () => {
        this.setState({
            data: [],
            searchActive: false,
            searchKeywords: '',
            page: 0
        }, this.fetchData)
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        this.setState({
            data: [],
            searchActive: true,
            page: 0
        }, this.fetchData)
    };

    render() {
        return (
            <React.Fragment>
                <div className="nav_content_search_container" style={{padding: 12, paddingTop: 20}}>
                    <Form onSubmit={this.handleSearchSubmit}>
                        <FormGroup>
                            <InputGroup style={{width: "100%"}}>
                                <FormControl
                                    style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 4}}
                                    placeholder={'Search templates'}
                                    value={this.state.searchKeywords}
                                    type="text"
                                    onChange={(e) => this.handleSearchOnChange(e)}
                                />
                                {this.state.searchActive ?
                                    (<span onClick={this.handleSearchClear} style={{
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        right: 12,
                                        top: 9,
                                        fontSize: 22,
                                        zIndex: 100,
                                        color: '#C8CDD4'
                                    }} className="fas fa-times fa-2x fas-light"/>)
                                    : (<span onClick={this.handleSearchSubmit} style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        right: 12,
                                        top: 9,
                                        fontSize: 22,
                                        zIndex: 100,
                                        color: '#C8CDD4'
                                    }} className="fas fa-search fa-2x fas-light"/>)
                                }
                            </InputGroup>
                            <Button style={{'display': 'none'}} type='submit'/>
                        </FormGroup>
                    </Form>
                </div>

                <Select
                    styles={categorySelectionStyles}
                    className="template_category_select"
                    label="Design Template Category Select"
                    options={this.state.categories}
                    placeholder="Select Category"
                    value={this.state.selectedCategory}
                    onChange={((e) => {
                        this.handleCategoryChange(e)
                    })}
                />

                <InfiniteScroll
                    dataLength={this.state.data ? this.state.data.length : 0}
                    next={this.fetchData}
                    hasMore={true}
                    height={'calc(100vh - 198px)'}
                    endMessage={<h4>No more results.</h4>}
                >
                    <DesignResourcesPanel
                        on_drag_start={this.template_drag_start}
                        on_drag_end={this.template_drag_end}
                        on_drag={this.template_drag}
                        on_click={this.load_template}
                        image_height={'126px'}
                        col_size={6}
                        resources={this.state.data}
                    />
                </InfiniteScroll>

            </React.Fragment>
        );
    }
}

export default TemplatesPanel;